let module = angular.module('app.resources');

module.factory('OTT', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}`,
    { tenantId: '@tenantId' },
    {
      getSSOLink: {
        method: 'POST',
        url: `${API_ROOT}/tenants/:tenantId/login`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/ott.js